import Vue from 'vue'
import { Image } from 'element-ui'

Vue.use(Image)

// 创建指令
Vue.directive('image-preview', {
    bind(el) {
        processImages(el)
    },
    update(el) {
        // 内容更新时重新处理图片
        processImages(el)
    }
})

// 处理图片的函数
function processImages(el) {
    // 获取所有图片
    const images = el.getElementsByTagName('img')
    const imageList = Array.from(images).map(img => img.src)

    // 为每个图片添加点击事件
    Array.from(images).forEach(img => {
        // 如果图片已经被处理过，则跳过
        if (img.classList.contains('el-image')) return

        // 创建 el-image 组件
        const imageComponent = new Vue({
            render(h) {
                return h('el-image', {
                    props: {
                        src: img.src,
                        previewSrcList: imageList,
                        fit: 'contain',
                        zIndex: 3000
                    },
                    style: {
                        display: 'block',
                        width: '100%',
                        height: 'auto'
                    }
                })
            }
        }).$mount()

        // 替换原始图片
        img.parentNode.replaceChild(imageComponent.$el, img)
    })
}

// 添加全局样式
const style = document.createElement('style')
style.textContent = `
  .el-image {
    display: block;
    width: 100%;
    height: auto;
    cursor: pointer;
  }
  .el-image__inner {
    transition: all 0.3s;
  }
  .el-image__inner:hover {
    transform: scale(1.02);
  }
  .el-image-viewer__wrapper {
    z-index: 3000;
  }
`
document.head.appendChild(style) 